import { render } from "./selectGarmentProperties.vue?vue&type=template&id=43abe0d0&ts=true"
import script from "./selectGarmentProperties.vue?vue&type=script&lang=ts"
export * from "./selectGarmentProperties.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__